module.exports = __webpack_public_path__ + "static/img_2238-53ece30ae239837dc259223c6077445e.webp";